import { render, staticRenderFns } from "./RyanAtkins.vue?vue&type=template&id=c39d92e2&scoped=true&"
import script from "./RyanAtkins.vue?vue&type=script&lang=js&"
export * from "./RyanAtkins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39d92e2",
  null
  
)

export default component.exports